/**
 * Pause an async function for a set amount of time.
 */ export function delay(milliseconds) {
    return new Promise(function delayResolver(resolve) {
        window.setTimeout(resolve, milliseconds);
    });
}
